<template>
    <div class="main-menu-inner">
        <!-- LOGO -->
        <div class="topbar-left text-center">
            <a class="logo" href="/">
                        <span>
                            <img alt="logo-large" class="logo-lg logo-dark ml-0"
                                 src="@/assets/images/logo/stark-logo-sm.png">
                        </span>
            </a>
        </div>
        <!--end logo-->
        <div class="menu-body slimscroll">

            <div :class="{'active': activeMenu != null && activeMenu.title == activeMenuBar.title}"
                 :id="activeMenuBar.title"
                 class="main-icon-menu-pane">
                <div class="title-box">
                    <h6 class="menu-title">{{activeMenuBar.title}}</h6>
                </div>
                <ul :key="child.title" class="nav metismenu" v-for="child in activeMenuBar.childrens">
                    <li class="nav-item">
                        <router-link :to="{name: child.router}" class="nav-link" exact-active-class="active" href="#">
                            {{child.title}}
                        </router-link>
                    </li>
                </ul>
            </div><!-- end Dashboards -->
        </div><!--end menu-body-->
    </div>
</template>

<script>
    export default {
        name: 'MenuBar',
        props: {
            activeMenu: Object
        },
        data() {
            return {
                role: null,
                activeMenuBar: {
                    title: '',
                    roles: [],
                    router: '',
                    icon: '',
                    childrens: []
                }
            };
        },
        created() {
            this.role = this.$store.getters.role;
        },
        updated() {
            this.activeMenuBar = this.activeMenu != null ? this.activeMenu : this.activeMenuBar;
        }
    };
</script>

<style scoped>

</style>
